import { render } from "./EditFiliereNiveauMatiere..vue?vue&type=template&id=40e8d700&ts=true"
import script from "./EditFiliereNiveauMatiere..vue?vue&type=script&lang=ts"
export * from "./EditFiliereNiveauMatiere..vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__